<template>
  <div class="wrap">
    <TitleWithLine
        :nome="nome"
        :faculdadename="faculdadename"/>
    <div class="cargogrid">
      <Pessoa
          :urlpessoa="getPessoaUrl(cargo.Pessoa)"
          :nome="cargo.Pessoa.name"
          :cargo="cargo.Tipo"
          :imagem="cargo.Pessoa.image"
          v-for="cargo in cargos"/>
    </div>
  </div>
</template>

<script>
import Pessoa from "./Pessoa.vue";
import TitleWithLine from "./TitleWithLine.vue";
export default {
  name: "OrgaoSlide",
  props: ["nome","cargos","faculdadename","lang"],
  components: {
    Pessoa,
    TitleWithLine,
  },
  methods:{
    getPessoaUrl(Pessoa){
      const l = this.lang == "en" ? "en/":"";
      return `${import.meta.env.VITE_APP_SITE_URL}/${l}${Pessoa.url}`;
    }
  }
}
</script>

<style scoped>
.cargogrid {
  margin: 0;
  padding: 0;
  font-size: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 1fr;
  grid-column-gap: 1.875rem;
  grid-row-gap: 16px;
}

@media (max-width: 1280px) {
  .cargogrid{
    grid-column-gap: 11px;
    grid-row-gap: 12px;
  }
}

@media (max-width: 990px) {
  .cargogrid{
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: 1fr;
    grid-column-gap: 10px;
  }
}

@media (max-width: 767px) {
  .cargogrid {
    margin: 0;
    padding: 0;
    font-size: 0;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-auto-rows: 1fr;
    grid-column-gap: 1.875rem;
    grid-row-gap: 16px;
  }
}
</style>